export enum RefiScoreCheckResult {
  Fail = 'Fail',
  SummitLead = 'Summit Lead',
  Other = 'Other',
  Success = 'Success',
}
